module.exports = __webpack_public_path__ + "img/alipay.669cbc89.png";